export const iconFontAwesomeHouseholdCouch = (
	<i className="fa-solid fa-couch"></i>
);
